import { takeLatest } from 'redux-saga/effects';
import IntlTypes from '../constants';
import * as workers from './workers';

export default function* () {
  yield takeLatest(IntlTypes.CHANGE_LOCALE_START, workers.handleChangeLocale);
  yield takeLatest(IntlTypes.SET_INITIAL_LOCALE, workers.setInitialLocale);
}
